import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav3").addClass("active")
var swiper = new Swiper(".mySwiper", {
    navigation: {
      nextEl: ".section1 .swiper-button-next",
      prevEl: ".section1 .swiper-button-prev",
    },
  });